import resourceHelper from '@/Utils/resourceHelper';
import constants from '@/constants';

class MenuDataRepository {
  getGroupDetailsTabs() {
    return [
      {
        text: resourceHelper.getString('UsersTabTitle'),
        name: constants.tabNames.usersTab,
        pageComponentName: 'group-users-tab'
      },
      {
        text: resourceHelper.getString('LocationTabTitle'),
        name: constants.tabNames.locationTab,
        pageComponentName: 'group-location-tab'
      }
    ];
  }
}

export default new MenuDataRepository();